import styled from 'styled-components';

import { Flex } from '@/components/base';
import { useModalContext } from '@/components/Modal/Modal';
import useKeymap from '@/hooks/pure/useKeymap';

import SearchQueryBuilder from '../SearchQueryBuilder/SearchQueryBuilder';

const SearchFloat = () => {
  const { closeModal } = useModalContext();

  useKeymap('Escape', closeModal);

  return (
    <Style>
      <Flex className="search-query-builder-wrapper">
        <div
          style={{
            width: '100%',
          }}
        >
          <SearchQueryBuilder
            from="float"
            onSubmitCallback={closeModal}
            autoFocus
          />
        </div>
      </Flex>
    </Style>
  );
};

const Style = styled.div`
  width: 760px;
  height: 500px;
  position: relative;
  .search-query-builder-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

export default SearchFloat;
